import { cx } from '@twind/core';
import { Category } from 'app/services/helpCenter';
import { Subheading, Title } from 'app/components/Typography';
import useFeatureFlags from 'app/hooks/useFeatureFlags';
import { useNavigate } from 'react-router-dom';
import useWebchatVersion from 'app/hooks/useWebchatVersion';
import { useTailorHalfOpen } from 'app/hooks/useTailorHalfOpen';
import { ChatModuleType, SuggestedEntry } from 'app/copied/models/ChatModules';
import useModule from 'app/hooks/useModule';
import { ChatVersion } from 'app/copied/constants/common';

import TailorCategories from '../../components/TailorCategories';
import TailorMostRequested from '../../components/TailorMostRequested';
import useTailorTracking from '../../hooks/useTailorTracking';

export default function TailorLandingCategories({
  categories,
  onClickFaq,
  className,
}: {
  categories: Category[];
  onClickFaq: (result: SuggestedEntry, index: number) => void;
  className?: string;
}) {
  const { uiRefreshReduceWhitespaceBetweenCategories, uiRefreshSuggestedArticlesHeading } = useFeatureFlags();
  const navigate = useNavigate();
  const { captureLandingPageCategoryClicked } = useTailorTracking();
  const webchatVersion = useWebchatVersion();
  const { halfOpen } = useTailorHalfOpen();
  const tailorModule = useModule(ChatModuleType.TAIlor);

  const isV41 = webchatVersion === ChatVersion.v4_1;
  const containerPadding = isV41 ? 'pt-9' : 'pt-5';

  return (
    <div
      id="ostro-tailor-landing-categories-container"
      className={cx(
        `~(${containerPadding} ${uiRefreshReduceWhitespaceBetweenCategories ? 'pb-10 mb-[-1px]' : 'pb-16'} px-7 grow)`,
        className
      )}
    >
      {categories.length > 0 && (
        <TailorCategories
          className="mt-6"
          onClickCategory={(category, index) => {
            navigate(`/tailor/category/${encodeURIComponent(category.name)}`);
            captureLandingPageCategoryClicked(category, {
              resultIndex: index + 1,
              halfAutoOpen: halfOpen,
            });
          }}
          categories={categories}
        />
      )}
      {categories.length === 0 && (
        <TailorMostRequested
          title={uiRefreshSuggestedArticlesHeading || (isV41 ? undefined : '')}
          showArticleDescriptions={false}
          articleTitleComponent={isV41 ? Subheading : Title}
          searchResults={tailorModule?.config?.suggested_entries}
          onSelectResult={onClickFaq}
        />
      )}
    </div>
  );
}
